<template>
  <div class="animated fadeIn accelerator-requests">
    <!-- loading component -->
    <div role="tablist">
      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1 border-0" role="tab">
          <b-button block v-b-toggle.accordion-2 variant="dark">
            <h5 class="mb-0" style="display: inline-block">اطلاعات مقاله</h5>
          </b-button>
        </b-card-header>
        <b-collapse
          id="accordion-2"
          visible
          accordion="my-accordion"
          role="tabpanel"
        >
          <b-card-body>
            <b-card-text class="p-3">
              <ul>
                <li>
                  <strong class="c-purple">عنوان به زبان فارسی: </strong>
                  {{ proposal.faSubject }}
                </li>
                <li>
                  <strong class="c-purple">عنوان به زبان انگلیسی: </strong>
                  {{ proposal.enSubject }}
                </li>
                <li>
                  <strong class="c-purple">دانشگاه محل اجرای مقاله: </strong>

                  {{
                    proposal.universityId
                      ? universities.filter(
                          (x) => x.id == proposal.universityId
                        )[0]
                        ? universities.filter(
                            (x) => x.id == proposal.universityId
                          )[0].text
                        : ""
                      : ""
                  }}
                </li>
                <li v-if="proposal.universityId == notUniversity">
                  <strong class="c-purple">نام دانشگاه: </strong>
                  {{ proposal.otherUniversity }}
                </li>
                <li v-if="proposal.mehvarId != notMehvar">
                  <strong class="c-purple">محور مقاله: </strong>
                  {{
                    proposal.mehvarId
                      ? mehvars.filter((x) => x.id == proposal.mehvarId)[0]
                        ? mehvars.filter((x) => x.id == proposal.mehvarId)[0]
                            .text
                        : ""
                      : ""
                  }}
                </li>
                <li v-if="proposal.mehvarId == notMehvar">
                  <strong class="c-purple">محور مقاله: </strong> سایر محورها
                </li>
                <li v-if="proposal.mehvarId == notMehvar">
                  <strong class="c-purple">نام محور: </strong
                  >{{ proposal.otherMehvars }}
                </li>
                <li>
                  <strong class="c-purple">ماهیت مقاله: </strong>
                  <b-form-group disabled>
                    <b-form-checkbox v-model="proposal.typeStudy"
                      >مطالعاتی</b-form-checkbox
                    >
                    <b-form-checkbox
                      v-model="proposal.typeSystemicDevelopmental"
                      >سیستمی و توسعه‌ای</b-form-checkbox
                    >
                    <b-form-checkbox v-model="proposal.typePractical"
                      >کاربردی</b-form-checkbox
                    >
                  </b-form-group>
                </li>
                <li>
                  <strong class="c-purple">حوزه مقاله: </strong>
                  <b-form-group disabled>
                    <b-form-checkbox v-model="proposal.zoneMedicine"
                      >پزشکی</b-form-checkbox
                    >
                    <b-form-checkbox v-model="proposal.zoneAgriculture"
                      >کشاورزی</b-form-checkbox
                    >
                    <b-form-checkbox v-model="proposal.zoneEnvironment"
                      >محیط زیست</b-form-checkbox
                    >
                    <b-form-checkbox v-model="proposal.zoneIndustrial"
                      >صنعتی</b-form-checkbox
                    >
                    <b-form-checkbox v-model="proposal.zoneBioComputing"
                      >رایانش زیستی</b-form-checkbox
                    >
                    <b-form-checkbox v-model="proposal.zoneOther"
                      >سایر</b-form-checkbox
                    >
                  </b-form-group>
                </li>
              </ul>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-3 variant="light">
            <h5 class="mb-0" style="display: inline-block">اطلاعات نویسنده</h5>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text class="p-3">
              <div class="custom-table">
                <b-table
                  responsive
                  small
                  show-empty
                  stacked="sm"
                  tbody-tr-class="trClass"
                  thead-class="thClass"
                  :items="proposal.colleagues"
                  :fields="writersField"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                </b-table>
              </div>
              <b-form-group disabled>
                <div class="d-flex mt-4" dir="rtl">
                  <b-form-checkbox
                    v-model="proposal.responsibleAuthor"
                  ></b-form-checkbox>
                  <label class="ml-2"
                    ><h6 class="c-purple">نویسنده‌ی مسئول مقاله هستم</h6></label
                  >
                </div>
              </b-form-group>
              <li v-if="!proposal.responsibleAuthor">
                <strong class="c-purple">رضایتنامه نویسنده مسئول: </strong>
                <a
                  v-if="proposal.consentResponsibleAuthorFile"
                  :href="proposal.consentResponsibleAuthorFile"
                  target="blank"
                  >دانلود</a
                >
                <span v-else> -- </span>
              </li>
              <br />
              <li>
                <strong class="c-purple">شماره شبا: </strong
                >{{ proposal.executorIBAN }}
              </li>
              <li>
                <strong class="c-purple">نام بانک: </strong
                >{{ proposal.executorBankName }}
              </li>
              <li>
                <strong class="c-purple">نام صاحب حساب: </strong
                >{{ proposal.executorBankAccountName }}
              </li>
              <li>
                <strong class="c-purple">شماره تماس: </strong
                >{{ proposal.executorTel }}
              </li>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-4 variant="warning">
            <h5 class="mb-0" style="display: inline-block">مشخصات</h5>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text class="p-3">
              <ul>
                <li>
                  <strong class="c-purple">عنوان به زبان انگلیسی: </strong
                  >{{ proposal.enSubject }}
                </li>
                <li>
                  <strong class="c-purple">چکیده: </strong
                  >{{ proposal.abstract }}
                </li>
                <li>
                  <strong class="c-purple">کلید واژگان: </strong
                  >{{ proposal.keywords }}
                </li>
                <li>
                  <strong class="c-purple">شناسه دیجیتال مجله: </strong>
                  <span dir="ltr">{{ proposal.doi }}</span>
                </li>
                <li>
                  <strong class="c-purple">ISSN مجله: </strong>
                  <div v-if="proposal.ISSN">
                    <div
                      v-for="(item, index) in proposal.ISSN"
                      :key="index"
                      class="badge"
                    >
                      <h6 class="mb-0">
                        <b-badge pill>{{ item }}</b-badge>
                      </h6>
                    </div>
                  </div>
                </li>

                <li>
                  <strong class="c-purple">ضریب تاثیر مجله: </strong
                  >{{ proposal.impactFactor }}
                </li>
                <li>
                  <strong class="c-purple">تشکرات: </strong
                  >{{ proposal.acknowledgment }}
                </li>
                <li>
                  <strong class="c-purple">فایل PDF مقاله: </strong>
                  <a
                    v-if="proposal.articlePdfFile"
                    :href="proposal.articlePdfFile"
                    target="blank"
                    >دانلود</a
                  >
                  <span v-else> -- </span>
                </li>
              </ul>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-5 variant="info">
            <h5 class="mb-0 text-white" style="display: inline-block">
              زمانبندی
            </h5>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text class="p-3">
              <ul>
                <li>
                  <strong class="c-purple">تاریخ چاپ (شمسی): </strong
                  >{{ proposal.articlePublicationDate }}
                </li>
                <li>
                  <strong class="c-purple">تاریخ چاپ (میلادی): </strong>
                  {{
                    proposal.articlePublicationDate
                      ? moment(
                          proposal.articlePublicationDate,
                          "jYYYY/jMM/jDD"
                        ).format("YYYY/MM/DD")
                      : "-"
                  }}
                </li>
                <li>
                  <strong class="c-purple">تاریخ ثبت (شمسی): </strong
                  >{{ proposal.articleSubmissionDate }}
                </li>
                <li>
                  <strong class="c-purple">تاریخ ثبت (میلادی): </strong>
                  {{
                    proposal.articleSubmissionDate
                      ? moment(
                          proposal.articleSubmissionDate,
                          "jYYYY/jMM/jDD"
                        ).format("YYYY/MM/DD")
                      : "-"
                  }}
                </li>
                <li>
                  <strong class="c-purple">تاریخ بازبینی (شمسی): </strong
                  >{{ proposal.articleRevisionDate }}
                </li>
                <li>
                  <strong class="c-purple">تاریخ بازبینی (میلادی): </strong
                  >{{
                    proposal.articleRevisionDate
                      ? moment(
                          proposal.articleRevisionDate,
                          "jYYYY/jMM/jDD"
                        ).format("YYYY/MM/DD")
                      : "-"
                  }}
                </li>
                <li>
                  <strong class="c-purple">تاریخ پذیرش (شمسی): </strong
                  >{{ proposal.articleAcceptanceDate }}
                </li>
                <li>
                  <strong class="c-purple">تاریخ پذیرش (میلادی): </strong
                  >{{
                    proposal.articleAcceptanceDate
                      ? moment(
                          proposal.articleAcceptanceDate,
                          "jYYYY/jMM/jDD"
                        ).format("YYYY/MM/DD")
                      : "-"
                  }}
                </li>
                <li>
                  <strong class="c-purple">تاریخ انتشار (شمسی): </strong
                  >{{ proposal.articleReleaseDate }}
                </li>
                <li>
                  <strong class="c-purple">تاریخ انتشار (میلادی): </strong
                  >{{
                    proposal.articleReleaseDate
                      ? moment(
                          proposal.articleReleaseDate,
                          "jYYYY/jMM/jDD"
                        ).format("YYYY/MM/DD")
                      : "-"
                  }}
                </li>
              </ul>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-6 variant="warning">
            <h5 class="mb-0" style="display: inline-block">میزان وجه تشویقی</h5>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text class="p-3">
              <ul>
                <b-form-group label="مبلغ:">
                  <div
                    v-if="
                      0 < proposal.impactFactor && proposal.impactFactor < 4
                    "
                  >
                    <h3 class="c-purple">2,000,000 تومان</h3>
                  </div>
                  <div
                    v-else-if="
                      4 <= proposal.impactFactor && proposal.impactFactor <= 8
                    "
                  >
                    <h3 class="text-success">3,000,000 تومان</h3>
                  </div>
                  <div v-else-if="proposal.impactFactor > 8">
                    <h3 class="text-success">4,000,000 تومان</h3>
                  </div>
                </b-form-group>
              </ul>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-7 variant="dark">
            <h5 class="mb-0" style="display: inline-block">تعهدات</h5>
          </b-button>
        </b-card-header>
        <b-collapse id="accordion-7" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-card-text class="p-3">
              <b-form-group disabled>
                <b-form-checkbox
                  :class="proposal.promiseArrays[0] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[0]"
                  >این مقاله در بخش حمایت از رساله های دکتری و یا در بخش حمایت
                  از پایان نامه های ارشد زیست فناوری مورد حمایت قرار نگرفته
                  است.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[1] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[1]"
                  >ملاک IF بر اساس JCR سال 2018 مورد تایید خواهد
                  بود.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[2] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[2]"
                  >ملاک میزان حمایت میزان دقیق IF خواهد بود.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[3] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[3]"
                  >ثبت در خواست هیچگونه حقی برای پذیرش مقاله ایجاد نمی
                  کند.</b-form-checkbox
                ></b-form-group
              >
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>

<script>
import moment from "moment-jalaali"; // NOTE (IMPORT) to convert dates to each other
const sarmadGantt = () => import("./../components/sarmadGantt");
import Select2 from "v-select2-component";
export default {
  props:['proposal','universities','mehvars','companies'],
  components: {
    Select2, // NOTE (COMPONENT) component of select2 plugin
    sarmadGantt: sarmadGantt, // NOTE (COMPONENT) component of sarmad gantt chart
  },
  data() {
    return {
      pageLoaded: false,
      moment: moment,
      colleague: {},
      tabIndex: 0,
      isLoaded: false,
      writersField: [
        { key: "index", label: "#" },
        { key: "nameEn", label: "نام و نام خانوادگی (انگلیسی)" },
        { key: "name", label: "نام و نام خانوادگی (فارسی)" },
        { key: "nationality", label: "ملیت" },
        { key: "position", label: "نقش نویسنده" },
      ],
      acc: 0,
      exportDate: moment(new Date()).format("jDD/jMM/jYYYY"),
    };
  },
  methods: {
    saveDocx(element) {
      var preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>sarmad</title><style>.done{color: black} .required{color:red} strong{font-family:B Titr;} table, td, th {border: 1px solid black} table {width:100%; border-collapse: collapse} .all{direction : rtl; text-align: right} body{font-family:B Nazanin;}</style></body></body></head><body>";
      var postHtml = "</body></html>";
      var html =
        preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(["\ufeff", html], {
        type: "application/msword",
      });

      // Specify link url
      var url =
        "data:application/vnd.ms-word;charset=utf-8," +
        encodeURIComponent(html);

      // Specify file name
      let filename = this.proposal.requestsCode + ".doc";

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }

      document.body.removeChild(downloadLink);
    },
  },
};
</script>

<style></style>
